exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3C46WTkavwNpL2s9wi5NWq{position:absolute;bottom:-6px;width:100%}html[dir=ltr] ._3C46WTkavwNpL2s9wi5NWq{left:0}html[dir=rtl] ._3C46WTkavwNpL2s9wi5NWq{right:0}._3C46WTkavwNpL2s9wi5NWq .ms-ProgressIndicator .ms-ProgressIndicator-progressBar,._3C46WTkavwNpL2s9wi5NWq .ms-ProgressIndicator .ms-ProgressIndicator-progressTrack{height:4px}", ""]);
// Exports
exports.locals = {
	"progressIndicator": "_3C46WTkavwNpL2s9wi5NWq"
};